module.exports = __webpack_public_path__ + "static/media/Gallery-12.0f7fb3aa.jpg";